import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#73AF00"
  }} d="M473.885,88.279H38.115C17.045,88.403,0,105.517,0,126.617v258.759  c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345V126.617  C512,105.517,494.955,88.403,473.885,88.279z" /><g><rect y={150.07} style={{
      fill: "#F5F5F5"
    }} width={512} height={35.31} /><rect y={326.62} style={{
      fill: "#F5F5F5"
    }} width={512} height={35.31} /></g><rect y={185.38} style={{
    fill: "#C8414B"
  }} width={512} height={141.24} /><path style={{
    fill: "#FFE15A"
  }} d="M253.801,201.617l-12.854,38.541l-40.627,0.314c-2.228,0.018-3.15,2.86-1.359,4.183l32.683,24.135  l-12.255,38.737c-0.672,2.124,1.746,3.881,3.559,2.585L256,286.487l33.053,23.625c1.812,1.295,4.23-0.461,3.559-2.585  l-12.255-38.737l32.683-24.135c1.792-1.323,0.868-4.166-1.359-4.183l-40.627-0.314L258.2,201.617  C257.494,199.505,254.506,199.505,253.801,201.617z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };